<!-- 关于瑞摩 -->
<template>
    <!-- pc -->
    <div v-if="deviceType === 'pc'" class="container_pc">
        <div class="introduceBox">
            <div class="title">
                <span>瑞摩宅兹</span>
            </div>
            <div class="content">
                <span>智能家居全屋方案设计</span>
                <span>让每一位家庭成员享受智慧生活</span>
            </div>
        </div>
        <div class="systemBox">
            <div v-if="!IsShowIosHover" class="iosBox" :style="{'--opcity': IsShowIosHover === false && IsShowAndroidHover === false?'1': '0'}">
                <div @mouseenter="handleMouseEnter('ios')" class="ios">
                    <img src="../assets/AppleIcon.png">
                    <span>iOS</span>
                </div>
            </div>
            <div v-else @mouseleave="handleMouseLeave('ios')" class="iosHover">
                <div class="codeBox">
                    <Qrcode :value="iosDownloadUrl" size="224"></Qrcode>
                </div>
                <div class="codeSource">
                    <img src="../assets/AppleHoverIcon.png">
                    <span>iOS</span>
                </div>
            </div>
            <div v-if="!IsShowAndroidHover" class="androidBox">
                <div @mouseenter="handleMouseEnter('android')" class="android">
                    <img src="../assets/AndroidIcon.png">
                    <span>Android</span>
                </div>
            </div>
            <div v-else @mouseleave="handleMouseLeave('android')" class="androidHover">
                <div class="codeBox">
                    <Qrcode :value="androidDownloadUrl" size="224"></Qrcode>
                </div>
                <div class="codeSource">
                    <img src="../assets/AndroidHoverIcon.png">
                    <span>Android</span>
                </div>
            </div>
        </div>
    </div>
    <!-- 笔记本 -->
    <div v-if="deviceType === 'mac'" class="container_mac">
        <div class="introduceBox">
            <div class="title">
                <span>瑞摩宅兹</span>
            </div>
            <div class="content">
                <span>智能家居全屋方案设计</span>
                <span>让每一位家庭成员享受智慧生活</span>
            </div>
        </div>
        <div class="systemBox">
            <div v-if="!IsShowIosHover" class="iosBox" :style="{'--opcity': IsShowIosHover === false && IsShowAndroidHover === false?'1': '0'}">
                <div @mouseenter="handleMouseEnter('ios')" class="ios">
                    <img src="../assets/AppleIcon.png">
                    <span>iOS</span>
                </div>
            </div>
            <div v-else @mouseleave="handleMouseLeave('ios')" class="iosHover">
                <div class="codeBox">
                    <Qrcode :value="iosDownloadUrl" size="224"></Qrcode>
                </div>
                <div class="codeSource">
                    <img src="../assets/AppleHoverIcon.png">
                    <span>iOS</span>
                </div>
            </div>
            <!-- <div class="line"></div> -->
            <div v-if="!IsShowAndroidHover" class="androidBox">
                <div @mouseenter="handleMouseEnter('android')" class="android">
                    <img src="../assets/AndroidIcon.png">
                    <span>Android</span>
                </div>
            </div>
            <div v-else @mouseleave="handleMouseLeave('android')" class="androidHover">
                <div class="codeBox">
                    <Qrcode :value="androidDownloadUrl" size="224"></Qrcode>
                </div>
                <div class="codeSource">
                    <img src="../assets/AndroidHoverIcon.png">
                    <span>Android</span>
                </div>
            </div>
        </div>
    </div>
    <!-- phone -->
    <div v-if="deviceType === 'phone'" class="container_phone">
        <div class="introduceBox">
            <div class="title">
                <span>瑞摩宅兹</span>
            </div>
            <div class="content">
                <span>智能家居全屋方案设计</span>
                <span>让每一位家庭成员享受智慧生活</span>
            </div>
        </div>
        <div class="systemBox">
            <div @click="download('ios')" class="ios">
                <img src="../assets/AppleHoverIcon.png">
                <span>iOS</span>
            </div>
            <div @click="download('android')" class="android">
                <img src="../assets/AndroidHoverIcon.png">
                <span>Android</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import Qrcode from 'qrcode.vue';
import { ref, onMounted, onUnmounted } from 'vue'


/**
 * 二维码相关逻辑模块
 */
let iosDownloadUrl = ref('https://apps.apple.com/cn/app/%E7%91%9E%E6%91%A9%E5%AE%85%E5%85%B9/id6739554926')
let androidDownloadUrl = ref('https://hcdn-iot.houzzkit.com/app/houzzkit.apk')
let IsShowIosHover = ref(false)
let IsShowAndroidHover = ref(false)

const handleMouseEnter = (type) => {
    if (type === 'ios') {
        IsShowIosHover.value = true
    } else {
        IsShowAndroidHover.value = true
    }
};

const handleMouseLeave = (type) => {
    if (type === 'ios') {
        IsShowIosHover.value = false
    } else {
        IsShowAndroidHover.value = false
    }
};


/**
 * 手机端点击下载的逻辑模块
 */
const download = (type) => {
    if (type === 'ios') {
        window.location.href = iosDownloadUrl.value
    } else if (type === 'android') {
        window.location.href = androidDownloadUrl.value
    }
}


/**
 * 屏幕尺寸功能模块
 */
const screenWidth = ref(window.innerWidth)
const deviceType = ref('')

const updateDimensions = () => {
    screenWidth.value = window.innerWidth;
    console.log('屏幕尺寸', screenWidth.value)
    if (screenWidth.value < 1400) {
        deviceType.value = 'phone';  // 手机
    } else if (screenWidth.value < 1920) {
        deviceType.value = 'mac';  // 笔记本电脑(未提供ui，所以笔记本尺寸的样式只是前端看着调整的)
    } else {
        deviceType.value = 'pc';  // 大屏电脑
    }
};


onMounted(() => {
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
});


onUnmounted(() => {
    window.removeEventListener('resize', updateDimensions);
});
</script>

<style scoped lang="scss">
.container_pc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    background-image: url(../assets/uploadPageBgi.jpeg);
    background-repeat: no-repeat;
    background-size: cover;
    /* 或 contain */
    background-position: center;

    .introduceBox {
        margin-bottom: 138px;
        display: flex;
        flex-direction: column;
        width: 100%;

        .title {
            display: flex;
            justify-content: center;
            margin-bottom: 24px;
            width: 100%;

            span {
                font-weight: 630;
                font-size: 122px;
                color: #030935;
            }
        }

        .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;

            span {
                font-weight: 330;
                font-size: 54px;
                color: #65769D;
            }
        }
    }

    .systemBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 332px;
        .iosBox::after {
            content: '';
            position: absolute;
            bottom: 12px; /* 从顶部开始 */
            right: 0;
            width: 2px; /* 边框宽度 */
            height: 32px; /* 边框高度 */
            background-color: #FFFFFF4D;
            opacity: var(--opcity);
        }
        .iosBox {
            position: relative;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            width: 300px;
            height: 100%;
            .ios {
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                    margin-right: 20px;
                    width: 44px;
                    height: 44px;
                }

                span {
                    color: #FFF6F6;
                    font-weight: 380;
                    font-size: 40px;
                }
            }
        }

        .iosHover {
            padding: 30px 38px 8px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 300px;
            height: 332px;
            box-sizing: border-box;
            border-radius: 24px;
            background-color: #FFFFFF80;
            border: 2px solid #FFFFFF99;
            backdrop-filter: blur(100px);
            cursor: pointer;

            .codeBox {
                width: 100%;
                height: 224px;
                background-color: #fff;
            }

            .codeSource {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    margin-right: 20px;
                    width: 44px;
                    height: 44px;
                }

                span {
                    color: #030935;
                    font-weight: 380;
                    font-size: 40px;
                }
            }
        }

        .line {
            margin: 0 56px 0 96px;
            width: 0;
            height: 32px;
            border: 2px solid #FFFFFF4D;
        }

        .androidBox {
            position: relative;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            width: 300px;
            height: 100%;
            .android {
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                    margin-right: 20px;
                    width: 44px;
                    height: 44px;
                }

                span {
                    color: #FFF6F6;
                    font-weight: 380;
                    font-size: 40px;
                }
            }
        }

        .androidHover {
            padding: 30px 38px 8px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 300px;
            height: 332px;
            box-sizing: border-box;
            border-radius: 24px;
            background-color: #FFFFFF80;
            border: 2px solid #FFFFFF99;
            backdrop-filter: blur(100px);
            cursor: pointer;

            .codeBox {
                width: 100%;
                height: 224px;
                background-color: #fff;
            }

            .codeSource {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    margin-right: 20px;
                    width: 44px;
                    height: 44px;
                }

                span {
                    color: #030935;
                    font-weight: 380;
                    font-size: 40px;
                }
            }
        }
    }
}
.container_mac {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    background-image: url(../assets/uploadPageBgi.jpeg);
    background-repeat: no-repeat;
    background-size: cover;
    /* 或 contain */
    background-position: center;

    .introduceBox {
        margin-bottom: 138px;
        display: flex;
        flex-direction: column;
        width: 100%;

        .title {
            display: flex;
            justify-content: center;
            margin-bottom: 24px;
            width: 100%;

            span {
                font-weight: 630;
                font-size: 61px;
                color: #030935;
            }
        }

        .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;

            span {
                font-weight: 330;
                font-size: 27px;
                color: #65769D;
            }
        }
    }

    .systemBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 332px;
        .iosBox::after {
            content: '';
            position: absolute;
            bottom: 12px; /* 从顶部开始 */
            right: 0;
            width: 2px; /* 边框宽度 */
            height: 32px; /* 边框高度 */
            background-color: #FFFFFF4D;
            opacity: var(--opcity);
        }
        .iosBox {
            position: relative;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            width: 300px;
            height: 100%;
            // border: 1px solid #ccc;
            // border-right: none; /* 移除原右边框 */
            .ios {
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                    margin-right: 20px;
                    width: 44px;
                    height: 44px;
                }

                span {
                    color: #FFF6F6;
                    font-weight: 380;
                    font-size: 40px;
                }
            }
        }

        .iosHover {
            padding: 30px 38px 8px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 300px;
            height: 332px;
            box-sizing: border-box;
            border-radius: 24px;
            background-color: #FFFFFF80;
            border: 2px solid #FFFFFF99;
            backdrop-filter: blur(100px);
            cursor: pointer;

            .codeBox {
                width: 100%;
                height: 224px;
                background-color: #fff;
            }

            .codeSource {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    margin-right: 20px;
                    width: 44px;
                    height: 44px;
                }

                span {
                    color: #030935;
                    font-weight: 380;
                    font-size: 40px;
                }
            }
        }

        .line {
            margin: 0 56px 0 96px;
            width: 0;
            height: 32px;
            border: 2px solid #FFFFFF4D;
        }
        .androidBox {
            display: flex;
            align-items: flex-end;
            justify-content: center;
            width: 300px;
            height: 100%;
            .android {
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                    margin-right: 20px;
                    width: 44px;
                    height: 44px;
                }

                span {
                    color: #FFF6F6;
                    font-weight: 380;
                    font-size: 40px;
                }
            }
        }

        .androidHover {
            padding: 30px 38px 8px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 300px;
            height: 332px;
            box-sizing: border-box;
            border-radius: 24px;
            background-color: #FFFFFF80;
            border: 2px solid #FFFFFF99;
            backdrop-filter: blur(100px);
            cursor: pointer;

            .codeBox {
                width: 100%;
                height: 224px;
                background-color: #fff;
            }

            .codeSource {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    margin-right: 20px;
                    width: 44px;
                    height: 44px;
                }

                span {
                    color: #030935;
                    font-weight: 380;
                    font-size: 40px;
                }
            }
        }
    }
}
.container_phone {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    background-image: url(../assets/uploadPageBgi.jpeg);
    background-repeat: no-repeat;
    background-size: cover;
    /* 或 contain */
    background-position: center;

    .introduceBox {
        margin-bottom: 8rem;
        display: flex;
        flex-direction: column;
        width: 100%;

        .title {
            display: flex;
            justify-content: center;
            margin-bottom: .75rem;
            width: 100%;

            span {
                font-weight: 630;
                font-size: 2.875rem;
                color: #030935;
            }
        }

        .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;

            span {
                font-weight: 305;
                font-size: 1.25rem;
                color: #65769D;
            }
        }
    }

    .systemBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .ios {
            margin-bottom: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 11.5rem;
            height: 2.5rem;
            border-radius: 1.5rem;
            border: 1px solid #030935;
            backdrop-filter: blur(100px);

            img {
                margin-right: .5rem;
                width: 1.5rem;
                height: 1.5rem;
            }

            span {
                color: #030935;
                font-weight: 380;
                font-size: 1.25rem;
            }
        }

        .android {
            margin-bottom: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 11.5rem;
            height: 2.5rem;
            border-radius: 1.5rem;
            border: 1px solid #030935;
            backdrop-filter: blur(100px);

            img {
                margin-right: .5rem;
                width: 1.5rem;
                height: 1.5rem;
            }

            span {
                color: #030935;
                font-weight: 380;
                font-size: 1.25rem;
            }
        }
    }
}
</style>